module.exports = __webpack_public_path__ + "img/edit.f74a99a1.svg";